var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactiviewed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3811)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5351 58.0375L44.548 57.0752L44.5479 57.0749L45.5351 58.0375Z",
    fill: "#377DE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4819_3811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.948 34.684H43.2412C43.5171 35.4394 43.6678 36.2546 43.6678 37.1042V47.3342C43.6678 47.6884 43.6062 48.0285 43.494 48.3447H47.9689C49.6405 48.3447 51.0003 46.9847 51.0003 45.3132V39.7364C51.0004 36.9505 48.7339 34.684 45.948 34.684Z",
    fill: "url(#paint1_linear_4819_3811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3326 37.1043C23.3326 36.2546 23.4833 35.4395 23.7592 34.6841H21.0524C18.2665 34.6841 16 36.9506 16 39.7365V45.3134C16 46.9849 17.3599 48.3448 19.0315 48.3448H23.5064C23.3942 48.0285 23.3326 47.6885 23.3326 47.3343V37.1043Z",
    fill: "url(#paint2_linear_4819_3811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.594 32.0518H30.406C27.62 32.0518 25.3535 34.3184 25.3535 37.1043V47.3343C25.3535 47.8923 25.8059 48.3447 26.364 48.3447H40.6359C41.194 48.3447 41.6464 47.8923 41.6464 47.3343V37.1043C41.6464 34.3184 39.3799 32.0518 36.594 32.0518Z",
    fill: "url(#paint3_linear_4819_3811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 18.6551C30.1496 18.6551 27.4238 21.3809 27.4238 24.7313C27.4238 27.004 28.6782 28.9888 30.5306 30.0308C31.4092 30.5251 32.4221 30.8075 33.5 30.8075C34.5779 30.8075 35.5909 30.5251 36.4695 30.0308C38.322 28.9888 39.5762 27.0039 39.5762 24.7313C39.5762 21.3809 36.8504 18.6551 33.5 18.6551Z",
    fill: "url(#paint4_linear_4819_3811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8303 24.3186C20.3246 24.3186 18.2861 26.3571 18.2861 28.8628C18.2861 31.3685 20.3246 33.407 22.8303 33.407C23.4659 33.407 24.0712 33.2753 24.621 33.0386C25.5716 32.6294 26.3554 31.9049 26.8404 30.9974C27.1808 30.3605 27.3745 29.6339 27.3745 28.8628C27.3745 26.3571 25.336 24.3186 22.8303 24.3186Z",
    fill: "url(#paint5_linear_4819_3811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 24.3186C41.6645 24.3186 39.626 26.3571 39.626 28.8628C39.626 29.634 39.8196 30.3606 40.1601 30.9975C40.6451 31.905 41.4289 32.6295 42.3795 33.0387C42.9293 33.2753 43.5346 33.407 44.1702 33.407C46.6759 33.407 48.7144 31.3685 48.7144 28.8628C48.7144 26.3571 46.6759 24.3186 44.1702 24.3186Z",
    fill: "url(#paint6_linear_4819_3811)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.835 42C42.837 42 39.4415 45.4874 38.224 46.9083C37.9253 47.257 37.9253 47.743 38.224 48.0917C39.4415 49.5126 42.8367 53 46.835 53C50.8333 53 54.2285 49.5126 55.446 48.0917C55.7447 47.743 55.7447 47.257 55.446 46.9083C54.2285 45.4874 50.8333 42 46.835 42Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4432 46.9083C55.0261 46.4216 54.3533 45.6923 53.4884 44.9436C54.096 45.5136 54.5791 46.0423 54.905 46.4226C55.2037 46.7713 55.2037 47.2575 54.905 47.606C53.6875 49.0269 50.2923 52.5143 46.2941 52.5143C43.6656 52.5143 41.2976 51.0069 39.6377 49.5704C41.3003 51.1298 43.904 53 46.8323 53C50.8303 53 54.2258 49.5126 55.4432 48.0917C55.742 47.743 55.742 47.2568 55.4432 46.9083Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8357 51.787C49.4595 51.787 51.5864 49.8676 51.5864 47.4999C51.5864 45.1322 49.4595 43.2128 46.8357 43.2128C44.2119 43.2128 42.085 45.1322 42.085 47.4999C42.085 49.8676 44.2119 51.787 46.8357 51.787Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9088 44.2372C50.6152 44.9857 51.0439 45.9539 51.0439 47.0142C51.0439 49.382 48.9168 51.3013 46.2932 51.3013C45.1185 51.3013 44.0452 50.9144 43.2158 50.2769C44.0872 51.1998 45.3825 51.787 46.8314 51.787C49.4553 51.787 51.5822 49.8675 51.5822 47.4999C51.5822 46.1924 50.9314 45.0236 49.9088 44.2372Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8316 49.4753C48.0405 49.4753 49.0206 48.5909 49.0206 47.4999C49.0206 46.4089 48.0405 45.5245 46.8316 45.5245C45.6226 45.5245 44.6426 46.4089 44.6426 47.4999C44.6426 48.5909 45.6226 49.4753 46.8316 49.4753Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4529 47.7459C49.2538 47.7459 49.9029 47.1601 49.9029 46.4374C49.9029 45.7148 49.2538 45.1289 48.4529 45.1289C47.6521 45.1289 47.0029 45.7148 47.0029 46.4374C47.0029 47.1601 47.6521 47.7459 48.4529 47.7459Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1669 45.3059C49.2883 45.4973 49.3631 45.7156 49.3631 45.9519C49.3631 46.6747 48.714 47.2604 47.9131 47.2604C47.6515 47.2604 47.4093 47.1929 47.1973 47.0834C47.4473 47.4775 47.912 47.7461 48.4514 47.7461C49.2522 47.7461 49.9014 47.1604 49.9014 46.4376C49.9011 45.951 49.6034 45.5313 49.1669 45.3059Z",
    fill: "#F1F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3811",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3811",
    x1: 47.1208,
    y1: 34.684,
    x2: 47.1208,
    y2: 48.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4819_3811",
    x1: 19.8796,
    y1: 34.6841,
    x2: 19.8796,
    y2: 48.3448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4819_3811",
    x1: 33.5,
    y1: 32.0518,
    x2: 33.5,
    y2: 48.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4819_3811",
    x1: 33.5,
    y1: 18.6551,
    x2: 33.5,
    y2: 30.8075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4819_3811",
    x1: 22.8303,
    y1: 24.3186,
    x2: 22.8303,
    y2: 33.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4819_3811",
    x1: 44.1702,
    y1: 24.3186,
    x2: 44.1702,
    y2: 33.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4819_3811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactiviewed);
export default __webpack_public_path__ + "static/media/CONTACTIVIEWED.43b0cab10f441024ea18ce8962572c21.svg";
export { ForwardRef as ReactComponent };